// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Copyright ou © ou Copr. Université de Lorraine, (2022)
 *
 * Direction du Numérique de l'Université de Lorraine - SIED
 *  (dn-mobile-dev@univ-lorraine.fr)
 * JNESIS (contact@jnesis.com)
 *
 * Ce logiciel est un programme informatique servant à rendre accessible
 * sur mobile divers services universitaires aux étudiants et aux personnels
 * de l'université.
 *
 * Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français
 * et respectant les principes de diffusion des logiciels libres. Vous pouvez
 * utiliser, modifier et/ou redistribuer ce programme sous les conditions
 * de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA
 * sur le site "http://cecill.info".
 *
 * En contrepartie de l'accessibilité au code source et des droits de copie,
 * de modification et de redistribution accordés par cette licence, il n'est
 * offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,
 * seule une responsabilité restreinte pèse sur l'auteur du programme, le
 * titulaire des droits patrimoniaux et les concédants successifs.
 *
 * À cet égard, l'attention de l'utilisateur est attirée sur les risques
 * associés au chargement, à l'utilisation, à la modification et/ou au
 * développement et à la reproduction du logiciel par l'utilisateur étant
 * donné sa spécificité de logiciel libre, qui peut le rendre complexe à
 * manipuler et qui le réserve donc à des développeurs et des professionnels
 * avertis possédant des connaissances informatiques approfondies. Les
 * utilisateurs sont donc invités à charger et à tester l'adéquation du
 * logiciel à leurs besoins dans des conditions permettant d'assurer la
 * sécurité de leurs systèmes et/ou de leurs données et, plus généralement,
 * à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.
 *
 * Le fait que vous puissiez accéder à cet en-tête signifie que vous avez
 * pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les
 * termes.
 */
.logo {
  transform: translateY(0.1rem);
}

app-custom-icon {
  font-size: var(--icon-4-size);
  color: var(--ion-color-primary-contrast);
}

.tab-selected {
  color: var(--ion-color-secondary);
}
.tab-selected app-custom-icon {
  color: var(--ion-color-secondary);
}

.network-toolbar {
  height: 1.8rem;
  background-color: var(--ion-color-warning);
}

.no-network-label {
  color: black !important;
}

.menu-icon-badge {
  padding: calc(var(--icon-4-size) / 4);
  border-radius: 50%;
  background-color: var(--ion-color-danger);
  position: absolute;
  top: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/theme/app-theme/styles/app/layout.page.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AAuCA;EACE,6BAAA;AACF;;AAEA;EACE,6BAAA;EACA,wCAAA;AACF;;AAEA;EACE,iCAAA;AACF;AACE;EACE,iCAAA;AACJ;;AAGA;EACE,cAAA;EACA,0CAAA;AAAF;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACE,qCAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AAAF","sourcesContent":["/*!\n * Copyright ou © ou Copr. Université de Lorraine, (2022)\n *\n * Direction du Numérique de l'Université de Lorraine - SIED\n *  (dn-mobile-dev@univ-lorraine.fr)\n * JNESIS (contact@jnesis.com)\n *\n * Ce logiciel est un programme informatique servant à rendre accessible\n * sur mobile divers services universitaires aux étudiants et aux personnels\n * de l'université.\n *\n * Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français\n * et respectant les principes de diffusion des logiciels libres. Vous pouvez\n * utiliser, modifier et/ou redistribuer ce programme sous les conditions\n * de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA\n * sur le site \"http://cecill.info\".\n *\n * En contrepartie de l'accessibilité au code source et des droits de copie,\n * de modification et de redistribution accordés par cette licence, il n'est\n * offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,\n * seule une responsabilité restreinte pèse sur l'auteur du programme, le\n * titulaire des droits patrimoniaux et les concédants successifs.\n *\n * À cet égard, l'attention de l'utilisateur est attirée sur les risques\n * associés au chargement, à l'utilisation, à la modification et/ou au\n * développement et à la reproduction du logiciel par l'utilisateur étant\n * donné sa spécificité de logiciel libre, qui peut le rendre complexe à\n * manipuler et qui le réserve donc à des développeurs et des professionnels\n * avertis possédant des connaissances informatiques approfondies. Les\n * utilisateurs sont donc invités à charger et à tester l'adéquation du\n * logiciel à leurs besoins dans des conditions permettant d'assurer la\n * sécurité de leurs systèmes et/ou de leurs données et, plus généralement,\n * à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.\n *\n * Le fait que vous puissiez accéder à cet en-tête signifie que vous avez\n * pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les\n * termes.\n */\n\n.logo {\n  transform: translateY(0.1rem);\n}\n\napp-custom-icon {\n  font-size: var(--icon-4-size);\n  color: var(--ion-color-primary-contrast);\n}\n\n.tab-selected {\n  color: var(--ion-color-secondary);\n\n  app-custom-icon {\n    color: var(--ion-color-secondary);\n  }\n}\n\n.network-toolbar {\n  height: 1.8rem;\n  background-color: var(--ion-color-warning);\n}\n\n.no-network-label {\n    color: black !important;\n}\n\n.menu-icon-badge {\n  padding: calc(var(--icon-4-size) / 4);\n  border-radius: 50%;\n  background-color: var(--ion-color-danger);\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
